export const TabTypes = {
  TechnicalData: 'Technical data',
  ProductInformation: 'Product information',
  ProductSpecification: 'Product specification',
  Documents: 'Documents',
  DeliveryInfo: 'Delivery info',
  Faq: 'Faq',
};
